var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbletip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23 0c0 12.703-10.298 23-23 23 12.702 0 23 10.297 23 23V0z",
    fill: "current"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMgNDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZD0iTTIzIDBDMjMgMTIuNzAzIDEyLjcwMiAyMyAtMS4wMDUzNmUtMDYgMjNDMTIuNzAyIDIzIDIzIDMzLjI5NyAyMyA0NkwyMyAwWiIgZmlsbD0iY3VycmVudCIvPgo8L3N2Zz4K";
export { SvgBubbletip as ReactComponent };